import { Coordinates } from '../types/go-map-types';

/**
 * Converts app-level coordinates `{ latitude, longitude } to a Google Maps LatLngLiteral { lat, lng }.
 *
 * @param {Coordinates} coords - The app-friendly coordinate object (latitude/longitude).
 * @returns {google.maps.LatLngLiteral} A Google Maps–compatible literal with lat and lng.
 */
export function toLatLngLiteral(
    coords: Coordinates,
): google.maps.LatLngLiteral {
    return { lat: coords.latitude, lng: coords.longitude };
}

/**
 * Normalizes a Google Maps LatLng (class) or LatLngLiteral into app-level Coordinates.
 *
 * @param {google.maps.LatLng | google.maps.LatLngLiteral} latLng - A Google position as a class instance or literal.
 * @returns {Coordinates} The normalized coordinate object { latitude, longitude }.
 */
export function fromLatLng(
    latLng: google.maps.LatLng | google.maps.LatLngLiteral,
): Coordinates {
    const lit = latLng instanceof google.maps.LatLng ? latLng.toJSON() : latLng;
    return { latitude: lit.lat, longitude: lit.lng };
}
